module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIxOS45NTYiPjxwYXRoIGRhdGEtbmFtZT0i7Yyo7IqkIDIwMDIiIGQ9Ik0zNzY2LjM0NiwzNTg4LjI0NWwtOS42ODctMTAuNTQxQTIsMiwwLDAsMSwzNzU5LjYsMzU3NWw2Ljc0Miw3LjMzNiwxMi4zMTMtMTMuNGEyLDIsMCwxLDEsMi45NDUsMi43MDdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzc1Ni4xMzEgLTM1NjguMjg5KSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/ico/ico_check.svg
// module id = phc2
// module chunks = 0